module.exports = __webpack_public_path__ + "img/bird.35ee0e24.jpg";